import Cookies from 'js-cookie'
import { Toast } from "vant";

const TokenKey = 'token'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function getData() {
  return localStorage.getItem("data");
}

export function setData(data) {
  return localStorage.setItem("data", JSON.stringify(data));
}
export function removeData() {
  return localStorage.removeItem("data");
}

export default {
  /**
   * 登录状态检查工具
   * 1. 检查localStorage中是否存在token
   * 2. 未登录时跳转到登录页
   * 3. 已登录时执行回调函数
   * @param {Function} callback 
   * @param {router} router 
   * @param {Boolean} isToken 
   */
  checkLogin(callback, router, isToken) {
    if (!isToken) {
      // 未登录跳转到登录页
      router.push('/login')
      Toast('请先登录迅流云');
    } else {
      // 已登录执行回调
      if (typeof callback === 'function') {
        callback()
      }
    }
  }
}




